module.exports = __webpack_public_path__ + "static/media/04 Konbini Duck.c9f2f11b.webp";